import * as React from 'react';

import { IqosApp, IqosEnvironmentId, IqosShell } from '@twosigmaiq/iqos-ui-platform';

// @ts-ignore
import { PolicySubmissionApp } from '@twosigmaiq/iqos-policy-submission-ui';
// @ts-ignore
import { PolicyApp } from '@twosigmaiq/iqos-policy-ui';

const apps: IqosApp[] = [new PolicySubmissionApp(), new PolicyApp()];

class App extends React.Component {
  render() {
    return (
      <IqosShell
        env={IqosEnvironmentId.demo}
        apps={apps}
        isTopBarDisabled={true}
      />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx